import customTheme from '@/constants/theme.custom';
import useIsMobile from '@/hooks/use-is-mobile';
import { Button, IconArrowLeft } from '@cmpsr/components';
import { useNavigate } from 'react-router-dom';

type BackButtonHrefProps = {
  to: string;
  onClick?: never;
  variant?: 'light' | 'dark';
};

type BackButtonClickProps = {
  to?: never;
  onClick: () => void;
  variant?: 'light' | 'dark';
};

function isBackButtonHrefProps(props: BackButtonProps): props is BackButtonHrefProps {
  return (props as BackButtonHrefProps).to !== undefined;
}

type BackButtonProps = BackButtonHrefProps | BackButtonClickProps;

export default function BackButton(props: BackButtonProps) {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const { variant = 'light' } = props;

  const handleClick = () => {
    if (isBackButtonHrefProps(props)) {
      const isExternal = props.to.match(/^https?:\/\//);

      if (isExternal) {
        // For external URLs
        window.location.href = props.to;
      } else {
        // For relative URLs, use React Router's navigate
        navigate(props.to);
      }
    } else {
      props.onClick();
    }
  };

  // Determine color based on variant
  const buttonColor = variant === 'dark' ? customTheme.colors['med-blue'] : 'text-light';

  return (
    <Button
      variant="link-accent"
      aria-label="Back"
      size="m"
      color={buttonColor}
      leadingIcon={<IconArrowLeft boxSize={isMobile ? 5 : 7} color={buttonColor} />}
      onClick={handleClick}
    />
  );
}
